// src/lib/BillToPicker.js
// Pick WHICH PERSON this document bills to. A company customer (the DMV)
// has one anchor customer on the project, but many individuals open tickets —
// this picker lists everyone sharing the anchor's business, plus a search
// for anyone else. Choosing the anchor (default) reports null to the parent
// so existing behavior is untouched unless a different person is picked.
// Styled for the light Stripe-style billing builders.
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE } from '../apiBase';

function BillToPicker({ project, value, onChange }) {
  const [all, setAll] = useState([]);
  const [searchQ, setSearchQ] = useState('');
  useEffect(() => {
    axios.get(`${API_BASE}/customers`, { headers: { Authorization: localStorage.getItem('token') } })
      .then((r) => setAll(r.data || [])).catch(() => {});
  }, []);
  const anchor = project?.customer;
  if (!anchor || !anchor._id) return null;
  const biz = (anchor.businessName || '').trim().toLowerCase();
  const mates = biz
    ? all.filter((c) => c._id !== anchor._id && (c.businessName || '').trim().toLowerCase() === biz)
    : [];
  const searched = searchQ.trim().length >= 2
    ? all.filter((c) => c._id !== anchor._id && !mates.some((m) => m._id === c._id)
        && `${c.name || ''} ${c.businessName || ''}`.toLowerCase().includes(searchQ.trim().toLowerCase())).slice(0, 5)
    : [];
  const cur = value || anchor;
  const pick = (c) => { onChange(c._id === anchor._id ? null : c); setSearchQ(''); };
  return (
    <div style={{ marginTop: '10px', padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
      <div style={{ fontSize: '12px', fontWeight: 700, color: '#525f7f', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: '6px' }}>
        Bill to{cur._id !== anchor._id && <span style={{ color: '#635bff', textTransform: 'none' }}> · {cur.name}</span>}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
        {[anchor, ...mates].map((c) => (
          <button key={c._id} onClick={() => pick(c)} type="button"
            style={{ padding: '5px 10px', borderRadius: '999px', fontSize: '13px', cursor: 'pointer',
              border: cur._id === c._id ? '1px solid #635bff' : '1px solid #d7dde6',
              background: cur._id === c._id ? '#eef0ff' : 'white',
              color: cur._id === c._id ? '#4f46e5' : '#425466', fontWeight: 600 }}>
            {c.name}{c._id === anchor._id ? ' (project)' : ''}
          </button>
        ))}
      </div>
      <input value={searchQ} onChange={(e) => setSearchQ(e.target.value)} placeholder="Bill someone else — search customers…"
        style={{ marginTop: '8px', width: '100%', padding: '8px 10px', border: '1px solid #d7dde6', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
      {searched.map((c) => (
        <div key={c._id} onClick={() => pick(c)}
          style={{ padding: '7px 10px', cursor: 'pointer', fontSize: '13px', borderBottom: '1px solid #eef2f6', background: 'white' }}>
          {c.name}{c.businessName ? ` — ${c.businessName}` : ''}
        </div>
      ))}
    </div>
  );
}

export default BillToPicker;
